import React, { useCallback, useEffect, useState } from 'react';
import {
  Loader,
  ScrollableDynamicTable,
  SearchBox,
  TOAST as Alert,
  Navigation,
  Button,
} from 'retro';
import { get } from 'App/Network/Axios';
import OpenIcon from '@atlaskit/icon/glyph/open';
import RefundRequest from './RefundRequest';
import moment from 'moment';
import { DownloadCsv } from 'retro/Utils';
import RBAC from 'App/HOCs/RBAC';
import ROLES from 'App/Constants/Roles';
import Filter from 'retro/Filter';
import FilterDropDown from 'App/Components/Filter/FilterDropDown';

const Refund = () => {
  let [loading, setLoading] = useState(true);
  const [id, setId] = useState(undefined);
  const [search, setSearch] = useState({
    page: 0,
    sort: 'id',
    order: 'desc',
  });
  const [Data, SetData] = useState({
    total: 0,
    currentPage: 0,
    totalPages: 0,
    items: [],
  });
  const [filterModal,setFilterModal] = useState(false);
	const [filter, setFilter] = useState({
		client: [],
	});
  // const loadPage = useCallback(
  //   (search) => {
  //     get(
  //       `/meta/train/refunding`,
  //       (e, r) => {
  //         if (r) {
  //           SetData({
  //             ...r,
  //             total: r.total || Data.total,
  //             totalPages: r.totalPages || Data.totalPages,
  //           });
  //           setLoading(false);
  //         } else {
  //           Alert.handleError(e);
  //         }
  //       },
  //       {
  //         offset: search.page,
  //         order: search.order,
  //         q: search.q,
  //       }
  //     );
  //   },
  //   [Data, SetData]
  // );
  const loadPage = useCallback(
    (search) => {
		const clients = filter.client.map(client => client.id).join(',');

      get(
        `/meta/train/refunding`,
        (e, r) => {
          if (r) {
            SetData({
              ...r,
              total: r.total || Data.total,
              totalPages: r.totalPages || Data.totalPages,
            });
            setLoading(false);
          } else {
            Alert.handleError(e);
          }
        },
        {
          offset: search.page,
          order: search.order,
          q: search.q,
          sort : search.sort,
		  client: clients.length > 0 ? clients : undefined
        }
      );
    },
    [Data, SetData, filter.client]
  );
  
  useEffect(() => {
    loadPage(search);
  }, [search, filter.client]);
  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      <div className="mb2 relative">
        <Navigation title="Request History" />
        <RBAC role={ROLES.REPORTS}>
          <Button
            onClick={() => {
              setLoading(true);
              get(`/meta/train/refunding/all`, (e, r) => {
                if (r) {
                  let data = [];
                  const headers = [
                    'Transaction Id',
                    'Reference Id',
                    'Origin City',
                    'Destination City',
                    'Train Name',
                    'Train Number',
                    'Train PNR',
                    'Request Date',
                  ];
                  data.push(headers);
                  r.items.forEach((item) => {
                    let line = [];
                    line.push([item.transId]);
                    line.push([item.referenceId]);
                    line.push([item.ticket?.originCity || '-']);
                    line.push([item.ticket?.destinationCity || '-']);
                    line.push([item.ticket?.trainName || '-']);
                    line.push([item.ticket?.trainNumber || '-']);
                    line.push([item.ticket?.trainPnr || '-']);
                    line.push([
                      moment(item.createdAt).format('DD MMM YYYY HH:mm a'),
                    ]);
                    data.push(line);
                  });
                  DownloadCsv(
                    `refund_queue${moment().format('DD_MM_YYYY')}}.csv`,
                    data
                  );
                }
                setLoading(false);
              });
            }}
            loading={loading}
            className="btn btn-primary btn-sm absolute top-2 right-0"
            style={{ zIndex: 10 }}
          >
            <i className="fa fa-download mr1" />
            Download Data
          </Button>
        </RBAC>
      </div>
      {/* <SearchBox
        onChange={(q) => {
          setSearch({
            ...search,
            page: 0,
            q,
          });
        }}
        placeholder="Enter your search criteria"
      /> */}
    <Filter
			margin="0 -4rem"
			onSearch={(q) => {
				setSearch({
					...search,
					page: 0,
					q,
				})
			}}
			onFilter={() => {
				setFilterModal(true)
			}}
		/>

		<FilterDropDown
			shown={filterModal}
			filters={filter}
			setFilters={setFilter}
			choices={{
				client: [],
			}}
			types={['Client']}
			onClose={() => {
				setFilterModal(false);
			}}
		/>
      <ScrollableDynamicTable
        setSearch={(search) => {
          setSearch({
            ...search,
            page: 0,
          });
        }}
        search={search}
        tableStyle={{
          borderSpacing: 0,
        }}
        setPage={(page) => {
          setSearch({
            ...search,
            page,
          });
        }}
        data={{
          current: Data.currentPage,
          total: Data.totalPages,
          items: Data.items.map((item) => {
            const click = () => {
              setId(item.queueId);
            };
            return {
              content: item,
              render: [
                {
                  children: (
                    <div>
                      <p className="text fw-bold">{item.transId}</p>
                      <p className="text">{item.referenceId || '-'}</p>
                      <p className="text-small text-light">
                        {item.ticket?.originCity} -{' '}
                        {item.ticket?.destinationCity}
                      </p>
                      <p className="text-small text-light">
                        {item.ticket?.trainName || '-'}
                      </p>
                    </div>
                  ),
                  weight: 1.5,
                },
                {
                  weight: 1,
                  title: moment(item.createdAt).format('DD MMM YYYY HH:mm a'),
                },
                {
                  weight: 1,
                  buttons: [
                    {
                      title: 'View',
                      className: 'btn-secondary btn-sm',
                      before: <OpenIcon size="small" />,
                      onClick: click,
                    },
                  ],
                  actions: [
                    {
                      title: 'Quick Actions',
                      actions: [
                        {
                          title: 'View',
                          before: <OpenIcon size="small" />,
                          onClick: click,
                        },
                      ],
                    },
                  ],
                },
              ],
            };
          }),
        }}
        headers={[
          {
            weight: 1.5,
            title: 'Details',
          },
          {
            weight: 1,
            title: 'Request Date',
          },
          {
            weight: 1,
            title: 'Actions',
            style: {
              justifyContent: 'end',
            },
          },
        ]}
      />
      {id !== undefined && (
        <RefundRequest
          id={id}
          onClose={() => {
            setId(undefined);
            loadPage(search);
          }}
        />
      )}
    </div>
  );
};

export default Refund;
